export const obterJsonManutencao = async () => {
    return await fetch("/config-manutencao.json?t=" + new Date().getTime());
};